import { TablePagination } from '@material-ui/core'
import ContentWrapper from 'components/ContentWrapper'
import ShapeFilesList from 'components/lists/ShapeFilesList'
import TopNavigation from 'components/navigation/TopNavigation'
import PaginationActions from 'components/tables/paginationActions'
import ShapeFileDrawer from 'containers/drawers/ShapeFileDrawer'
import {  useCachedShapeFileGroupsPicklistItems } from 'data/cache'
import { CompanyFormModel, PicklistItemModel } from 'data/models'
import { ShapeFileModel } from 'data/models/ShapefileModel'
import { useFormTemplatesServices, useShapeFilesService } from 'data/services'
import { uiSettings } from 'etc/settings'
import { createNotification } from 'factories/notificationFactory'
import React from 'react'
import { Helmet } from 'react-helmet'
import { Dialog, DialogContent, DialogTitle, Box, Typography, Paper } from '@material-ui/core'
import Button from 'components/Buttons'
import AddIcon from '@material-ui/icons/Add'
import { IRootReduxState } from 'types/reducers'
import { useSelector } from 'react-redux'

import { Dictionary } from 'types'
const ShapeFilesPage: React.FC = () => {
  const [selectedShapeFile, setSelectedShapeFile] = React.useState<ShapeFileModel | undefined>(undefined)
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(uiSettings.pagination.defaultRows)
  const [page, setPage] = React.useState<number>(0)
  const [pageOfUserGeneratedShapes, setPageOfUserGeneratedShapes] = React.useState<ShapeFileModel[]>([])
  const [shapeFiles, setShapeFiles] = React.useState<ShapeFileModel[]>([])
  const [completedForms, setCompletedForms] = React.useState<CompanyFormModel[]>([])
  const [shapefileGroupNames, setShapefileGroupNames] = React.useState<PicklistItemModel[]>([])
  const currentUser = useSelector((state: IRootReduxState) => state.app.user.current);

  const shapeFileService = useShapeFilesService()
  const formTemplatesService = useFormTemplatesServices()
  const picklistItemsService =useCachedShapeFileGroupsPicklistItems()

  const handleCreate= async (data:ShapeFileModel) => {
    if ( data) {
      data.CompanyId= currentUser?.CompanyId;
      await shapeFileService.addShape(data).then(()=>{
        createNotification.success('Shape Added Successfully')
        setSelectedShapeFile(undefined)
        getData()
      })
    }
  }
  const handleUpdate = async (id: number, data: Dictionary<any>) => {
    if (id && data) {
      await shapeFileService.updateShape(id, data as ShapeFileModel)
      createNotification.success('Shape Updated Successfully')
      setSelectedShapeFile(undefined)
      getData()
    }
  }

  const handleDelete = async (id: number) => {
    if (id) {
      await shapeFileService.deleteShape(id)
      createNotification.success('shape item deleted')
      setSelectedShapeFile(undefined)
      getData()
    }
  }

  const setPagedData = () => {
    const start = page * rowsPerPage
    const end = Math.min(start + (rowsPerPage - 1), shapeFiles.length)
    setPageOfUserGeneratedShapes(shapeFiles.slice(start, end))
  }

  const getData = async () => {
    setShapefileGroupNames(picklistItemsService)
    shapeFileService.getShapeFile().then((shapes) =>{ setShapeFiles(shapes)})
    formTemplatesService.getAll().then((forms) =>{ setCompletedForms(forms)})
  }

  React.useEffect(() => {
    setPagedData()
    // eslint-disable-next-line
  }, [page, rowsPerPage, shapeFiles])

  React.useEffect(() => {
    getData()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Helmet>
        <title>Settings / Shape Files</title>
        <meta name="shape files" content="shape files" />
      </Helmet>

       <Box px={3} py={2}>
      <Paper elevation={0} style={{ padding: '16px', borderRadius: '8px', border: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box style={{ flexGrow: 1, marginRight: '16px' }}>
 
          <Typography variant="h6">Shape Files Management</Typography>
        </Box>
            <Box>
              <Button.Button
                variant="contained"
                style={{ backgroundColor: '#163A64', color: '#fff' }}
                icon={<AddIcon style={{ fontSize: 20 }} />}
                label="Create New Shapefile"
                click={() => setSelectedShapeFile(new ShapeFileModel())} // Open drawer with new model
              />
            </Box>
          </Paper>
        </Box>

      <ContentWrapper>
        <ShapeFilesList shapeFile={pageOfUserGeneratedShapes} handleSelect={(shape) => setSelectedShapeFile({ ...shape })} />
        <TablePagination
          rowsPerPageOptions={uiSettings.pagination.rowsOptions}
          count={shapeFiles?.length || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          component="div"
          onChangePage={(e, page) => setPage(page)}
          onChangeRowsPerPage={(e) => {
            setRowsPerPage(+e.target.value)
            setPage(0)
          }}
          ActionsComponent={PaginationActions}
        />
      </ContentWrapper>

      {selectedShapeFile && (
      <ShapeFileDrawer forms={completedForms && completedForms} shapefileGroupNames={shapefileGroupNames} setSelectedShapeFile={setSelectedShapeFile} selectedShapeFile={selectedShapeFile} handleCreate={handleCreate} handleUpdate={handleUpdate} handleDelete={handleDelete}/>
      )}
    </>
  )
}

export default ShapeFilesPage
